import { ClientProvider } from "@nju/data-access-sales-client";
import { Footer } from "@nju/feature-portal-footer";
import { GoToNextNumber } from "@nju/feature-portal-order";
import { ClientOrderInfoBox } from "@nju/feature-sales-client";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { RespectOrchestratorState } from "@nju/feature-sales-orchestrator";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function GoToNextNumberPage() {
  return (
    <LayoutWrapper>
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <BlockContent>
        <ClientSideOnly>
          <RespectOrchestratorState
            allowMissingState={true}
            mode="mobile"
            state={["ITEM_SELECTION", "LEGACY_MIGRATION_ERROR", "MNP"]}
          >
            <ClientProvider>
              <ClientOrderInfoBox />
              <GoToNextNumber variant="sales" />
            </ClientProvider>
          </RespectOrchestratorState>
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
